import { getApiBaseUrl } from "../config";
import { normalizeExtractionMode } from "../constants/extractionModes";

export const REPLICATE_PROCESSAMENTO_STORAGE_KEY =
  "ikaro_replicate_processamento";

function parseJsonObject(value) {
  if (!value || typeof value === "object") {
    return value;
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return typeof parsed === "object" && parsed !== null ? parsed : null;
    } catch {
      return null;
    }
  }
  return null;
}

/**
 * Grava dados do job para replicar na tela "Novo processamento".
 * Exige template (input_payload) e documento com token em input_params.
 * Leva junto o extraction_mode para a réplica rodar no mesmo modo do original.
 */
export function persistProcessamentoJobForReplication(job) {
  let inputParams = job?.input_params;
  if (typeof inputParams === "string") {
    try {
      inputParams = JSON.parse(inputParams);
    } catch {
      inputParams = null;
    }
  }
  const doc = inputParams?.document;
  const inputPayload = parseJsonObject(job?.input_payload) ?? job?.input_payload;
  if (!inputPayload || typeof inputPayload !== "object" || !doc?.token) {
    return false;
  }
  const payload = {
    job_name: job.job_name || "",
    input_payload: inputPayload,
    /* Sem isto a réplica cairia no default da tela (Next-Set26) mesmo vindo de
       um job Standard, silenciosamente — a fidelidade ao original vale mais
       que o default da página. */
    extraction_mode: normalizeExtractionMode(inputParams?.extraction_mode),
    document: {
      token: doc.token,
      filename: doc.filename || "documento.pdf",
    },
  };
  try {
    sessionStorage.setItem(
      REPLICATE_PROCESSAMENTO_STORAGE_KEY,
      JSON.stringify(payload),
    );
    return true;
  } catch (e) {
    console.error("replicateProcessamentoJob: falha ao gravar sessionStorage", e);
    return false;
  }
}

/** Indica se a linha tem dados mínimos para replicar (ex.: Status de Tarefas, qualquer status). */
export function processamentoJobHasReplicateData(job) {
  let inputParams = job?.input_params;
  if (typeof inputParams === "string") {
    try {
      inputParams = JSON.parse(inputParams);
    } catch {
      return false;
    }
  }
  const inputPayload = parseJsonObject(job?.input_payload);
  if (!inputPayload || typeof inputPayload !== "object") {
    return false;
  }
  return Boolean(inputParams?.document?.token);
}

/**
 * Baixa o PDF de entrada do armazenamento (mesma URL que FileDownload).
 */
export async function fetchProcessamentoInputPdfBlob(
  fileToken,
  authToken,
  apiBaseUrl = getApiBaseUrl(),
) {
  const downloadUrl = `${apiBaseUrl}/files/download?token=${encodeURIComponent(
    fileToken,
  )}&Servicename=${encodeURIComponent("PROCESS_DIGITAL_PDF")}`;

  const response = await fetch(downloadUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${authToken}`,
      accept: "application/octet-stream",
    },
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.blob();
}
